import {FileUploadV2 as PeacockFileUpload} from '@pepsico-ds/ui'
import './FileUpload.scss'

/**
 * @typedef {import('@pepsico-ds/ui').IFileUploadV2Props} FileUploadProps
 * @property {import('@pepsico-ds/ui').ILabelProps | string} [label] File upload label configuration.
 * @property {string} [description] Optional description text.
 * @property {string} [accept] Comma-separated accepted file extensions.
 * @property {string} [buttonLabel] Custom upload button label.
 * @property {(file: File) => void} [onUpdate] Callback triggered when file is selected.
 * @property {(index: number) => void} [onDelete] Callback triggered when uploaded file is removed.
 * @property {(error: string) => void} [onFileError] Callback triggered for invalid file format.
 * @property {(file: File) => boolean} [onValidateFile] Callback to validate selected file before upload.
 * @property {import('@pepsico-ds/ui').UploadFile[]} [files] Uploaded file list.
 * @property {'default' | 'edit' | 'uploading' | 'complete'} [variant] File upload visual variant.
 * @property {boolean} [disabled] When true, input is disabled.
 * @property {boolean} [required] When true, marks upload input as required.
 * @property {string | import('react').ReactNode} [helperText] Helper text displayed below uploader.
 * @property {'image' | 'default'} [type] File upload type.
 * @property {string} [imageUri] Image URL displayed when type is image.
 * @property {string} [containerClassName] Custom class name for upload container.
 * @property {boolean} [showSkeleton] Renders skeleton state.
 * @property {number} [maxFiles] Maximum number of files allowed.
 * @property {string} [maxListHeight] Max height for uploaded files list container.
 * @property {boolean} [isShowUploadedFileCount] When true, displays uploaded file count.
 * @property {(index: number) => void} [onFilePause] Callback when pause is clicked for a file.
 * @property {(index: number) => void} [onFileResume] Callback when resume is clicked for a file.
 * @property {string} [uploadedFilesLabel] Optional label above uploaded files list.
 * @property {boolean} [disabledLabel] Disables label rendering.
 * @property {boolean} [disabledFeedback] Disables feedback rendering.
 * @property {boolean} [maxFilesUploaded] Disables uploads when max file count is reached.
 * @property {string | import('react').SVGProps<SVGSVGElement>} [uploadIcon] Custom icon for drag-and-drop area.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS FileUploadV2.
 * Supports all Peacock DS file upload props.
 * @param {FileUploadProps} props
 */

export const FileUpload = ({className, ...props}) => {
  return <PeacockFileUpload className={`custom-file-upload${className ? ` ${className}` : ''}`} {...props} />
}
